import '@fontsource-variable/geist';
import '@fontsource-variable/inter';
import './styles/main.css';
import './styles/precision.migration.css';
import './styles/workspace.compact.css';
import './styles/workspace.readable.css';
import './styles/charts.readable.css';
import './styles/forms.focus.css';
import './styles/ember.tokens.css';
import './styles/platform.controls.css';
import './styles/ember.platform.css';
import './styles/ember.workspace.css';
import './styles/scrollbars.css';
import './styles/motion.css';
import './styles/data-motion.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router/index.js';
import { armNotificationSound } from './utils/notificationSound.js';
import { initializeTheme } from './utils/theme.js';
import { surfaceMotion } from './utils/surface-motion.js';
import { tabMotion } from './utils/tab-motion.js';
import { dialogFocus } from './utils/dialog-focus.js';
import { chartMotion } from './utils/data-motion.js';

initializeTheme();

const app = createApp(App);
app.directive('surface-motion', surfaceMotion);
app.directive('dialog-focus', dialogFocus);
app.directive('motion-tabs', tabMotion);
app.directive('chart-motion', chartMotion);
app.use(createPinia());
app.use(router);
app.mount('#app');
armNotificationSound();

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', async () => {
    const registration = await navigator.serviceWorker.register('/service-worker.js?v=8', { updateViaCache: 'none' });
    await registration.update();
  });
}
